/**
 * Extract only digits and optional negative sign at the start
 * Used for integer inputs that can be negative (e.g., inventory)
 * @param value - Input string value
 * @returns String with only digits and optional leading negative sign
 */
export const getIntegerOnly = (value: string | undefined | null): string => {
  if (!value) return '';
  
  // Check if value starts with negative sign
  const isNegative = value.trim().startsWith('-');
  
  // Extract only digits
  const digitsOnly = value.replace(/\D/g, '');
  
  // Return with negative sign if original value started with it
  return isNegative ? `-${digitsOnly}` : digitsOnly;
};

